import { countScats, scatHoleInfo, scatStrokesForHole } from './ggPlayScats.js'

// Live Scats panel — mirrors the app's in-round scats panel: 🐈 Scats title +
// GROSS/NET tag, "X scats so far", the per-hole "birdie-or-better = scat" note,
// and a per-player scat table. NO dollars here — the pot settles at the end.
const row = { display: 'flex', justifyContent: 'space-between', fontSize: 16, padding: '3px 0' }

export default function GScatsLive({ game, hole }) {
  const s = game?.meta?.addons?.scats
  if (!s?.enabled) return null
  const course = game.meta.course || {}
  const pars = course.pars || []
  const all = game.players || []
  const players = all.filter((p) => !s.optedIn || s.optedIn.includes(p.id))
  const notIn = all.filter((p) => !players.includes(p)).map((p) => p.name.split(' ')[0])
  const counts = countScats(players, game.scores || {}, pars, { useHandicap: s.useHandicap, mode: s.mode, strokeIndex: course.strokeIndex })
  const total = counts.reduce((a, b) => a + b, 0)
  const tag = s.useHandicap ? `NET · ${(s.mode || 'cap1').toUpperCase()}` : 'GROSS'

  const par = pars[hole - 1] ?? 4
  // ONE winner per hole (outright lowest net under par); 2+ tied under par → none.
  const info = scatHoleInfo(players, game.scores || {}, pars, hole, { useHandicap: s.useHandicap, mode: s.mode, strokeIndex: course.strokeIndex })
  // Per-hole stroke dots — SAME source as the scat net (scatStrokesForHole), so
  // every player who gets a stroke this hole shows a dot that matches the net used
  // to award the scat. Fixes a net scat win looking like a tie when no dot showed.
  const strokes = scatStrokesForHole(players, hole, { useHandicap: s.useHandicap, mode: s.mode, strokeIndex: course.strokeIndex })
  const winner = info.winnerId ? players.find((p) => p.id === info.winnerId)?.name.split(' ')[0] : null
  const tiedNames = info.tied.map((id) => players.find((p) => p.id === id)?.name.split(' ')[0]).join(' & ')

  return (
    <div style={{ border: '1px solid #A5D6A7', borderRadius: 12, padding: 12, marginTop: 12, background: '#F1F8F1' }}>
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center gap-2">
          <span className="font-bold text-sm">🐈 Scats</span>
          <span className="text-[10px] font-bold px-2 py-0.5 rounded-full" style={{ backgroundColor: s.useHandicap ? '#1B7A3E' : '#E5E7EB', color: s.useHandicap ? '#fff' : '#374151' }}>{tag}</span>
        </div>
        <span className="text-xs text-gray-600">{total} scat{total === 1 ? '' : 's'} so far</span>
      </div>
      <div className="text-xs mb-2 rounded px-2 py-1" style={{ background: winner ? '#DCFCE7' : info.tied.length ? '#FEF3C7' : '#fff', border: '1px solid #E5E7EB', fontWeight: winner || info.tied.length ? 700 : 400, color: winner ? '#166534' : info.tied.length ? '#92400E' : '#6B7280' }}>
        {winner
          ? `🐦 ${winner} won the scat on hole ${hole}!${s.useHandicap ? ' (net — strokes applied)' : ''}`
          : info.tied.length
            ? `➗ ${tiedNames} tied under par on hole ${hole} — no scat`
            : `Hole ${hole} · par ${par} — lowest under par wins the scat`}
      </div>
      <div>
        {players.map((p, i) => (
          <div key={p.id} style={row}>
            <span>
              {strokes[i] > 0 && (
                <span title={`gets ${strokes[i]} stroke${strokes[i] === 1 ? '' : 's'} this hole`} style={{ color: '#F9A825', fontWeight: 900, letterSpacing: -1, marginRight: 4 }}>{'●'.repeat(Math.min(strokes[i], 2))}</span>
              )}
              {p.name}
            </span>
            <span className="font-bold">{counts[i]} scat{counts[i] === 1 ? '' : 's'}</span>
          </div>
        ))}
      </div>
      <p className="text-[11px] text-gray-500 mt-2">${s.buyIn} buy-in × {players.length} in — pot splits by total scats on the results screen.</p>
      {notIn.length > 0 && <p className="text-[11px] mt-0.5" style={{ color: '#B45309' }}>Not in Scats: {notIn.join(', ')} (their birdies don't count)</p>}
    </div>
  )
}
